module.exports = "<highcharts-chart   [Highcharts]=\"Highcharts\" \n  [options]=\"chartOptions\" \n  [(update)]=\"updateFlag\">\n</highcharts-chart>"